module.exports = __webpack_public_path__ + "assets/img/zj.4fbf1ef8.svg";